import { CheckCircleIcon, InfoIcon, Icon as PhosphorIcon, XCircleIcon } from '@phosphor-icons/react'

import { AlertType } from './alert.types'

export const AlertTypeToIconMap: Record<AlertType, PhosphorIcon> = {
  error: XCircleIcon,
  info: InfoIcon,
  success: CheckCircleIcon,
}
